module.exports = __webpack_public_path__ + "static/media/07-_DSC7025.b29aac4f.jpg";